import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import {
  FetchRulesArgs,
  FilterState,
  InitializeRulesArgs,
  Rule,
  Rules,
  Section,
  UpdateRulesArgs,
} from '../../dashboard/components/Rules/types';
import { axiosGetData, axiosPostData } from '../../helpers/axios';

export const fetchRules = createAsyncThunk(
  'rules/fetchRules',
  async (args: FetchRulesArgs, { rejectWithValue }) =>
    axiosGetData({
      ...args,
      rejectWithValue,
      headers: { 'Content-Type': 'application/json' },
    })
);

export const updateRules = createAsyncThunk(
  'rules/updateRules',
  async (args: UpdateRulesArgs, { rejectWithValue }) =>
    axiosPostData({
      ...args,
      data: args.rules,
      rejectWithValue,
      headers: { 'Content-Type': 'application/json' },
    })
);

export const backgroundFetchRules = createAsyncThunk(
  'rules/backgroundFetchRules',
  async (args: FetchRulesArgs, { rejectWithValue }) =>
    axiosGetData({
      ...args,
      rejectWithValue,
      headers: { 'Content-Type': 'application/json' },
    })
);

export const clearPendingChanges = createAction('rules/clearPendingChanges');
export const clearError = createAction('rules/clearError');
export const initializeRules = createAction<InitializeRulesArgs>(
  'rules/initializeRules'
);
export const reorderRules = createAction<{ ruleType: Section; rules: Rule[] }>(
  'rules/reorderRules'
);
export const setFilter = createAction<Partial<FilterState>>('rules/setFilter');
export const setIsLoading = createAction<boolean>('rules/setIsLoading');
export const setIsUpdating = createAction<boolean>('rules/setIsUpdating');
export const setRules = createAction<Rules>('rules/setRules');
